module.exports = __webpack_public_path__ + "static/media/IMG_7235.d06e95bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/square/IMG_7235.jpg
// module id = 145
// module chunks = 0